<template>
  <div></div>
</template>
<script>
import { getAuthorize, getWaitPayOrderList } from "@/api/api"
export default {
  components: {},
  data() {
    return {
      orderMsg: null,//链接携带信息
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      await this.getUrl()
      this.orderMsg = JSON.parse(localStorage.getItem("orderMsg")) || null
      console.log(this.orderMsg,'----orderMsg----')
      let technicianCodeSession = localStorage.getItem("technicianCodeSession") || ''
      if (!technicianCodeSession) {
        await this.getOauthUrl()
      }
      await this.getCode()
    },
    /* 根据链接跳转路径获取 */
    async getUrl() {
      let url = document.location.toString()
      if (url.indexOf('?code=') != -1) return ;//微信授权回调的链接
      const arrObj = url.indexOf('?') != -1 ? url.split('?') : []//获取?后参数
      const temp = arrObj.length ? arrObj[1] : ''
      const keyValue = url.indexOf('&') != -1 ? temp.split("&") : [];
      let obj = {};
      for (let i = 0; i < keyValue.length; i++) {//循环分割地址参数
        let item = keyValue[i].split("=");
        let key = item[0];
        let value = item[1];
        obj[key] = value;
      }
      localStorage.setItem("orderMsg",JSON.stringify(obj))
      let technicianCodeSession = localStorage.getItem("technicianCodeSession") || ''
      /* 截取参数后判断是否授权 */
      if(technicianCodeSession) {//授权
        console.log('已授权====')
        if (obj.brand == 'A02') {//西门子
          window.location.replace(this.$http + 'taro-pay/payment')
        } else if (obj.brand == 'A01') {//博世
          window.location.replace(this.$http + 'taro-pay/payment-bosch')
        }
      }
    },
    /* 获取授权url路径上的code */
    async getCode() {
      let url = document.location.toString()
      if (url.indexOf('?code=') == -1) return ;
      const arrObj = url.indexOf('?') != -1 ? url.split('?') : []//获取?后参数
      const temp = arrObj.length ? arrObj[1] : ''
      const keyValue = url.indexOf('&') != -1 ? temp.split("&") : [];
      let code = keyValue[0].split('=')[1]
      localStorage.setItem("code", code)
      if (this.orderMsg.brand == 'A02') {//西门子
        window.location.replace(this.$http + 'taro-pay/payment')
      }else if (this.orderMsg.brand == 'A01') {
        window.location.replace(this.$http + 'taro-pay/payment-bosch')
      }
    },
    
    /* 获取企业微信授权链接 */
    async getOauthUrl() {
      let str = location.href
      if (str.indexOf('?code=') != -1) return ;//微信授权回调的链接
      let redirect_uri = str.indexOf('?') ? str.split("?")[0] : str
      let query = {
        // agentId: 1000086,//博世西门子需区分
        // agentId: 1000035,
        // agentId: 1000088,//测试
        agentId: this.$agentId,
        redirectUri: redirect_uri,
        scope: 'snsapi_privateinfo'
      }
      await getAuthorize(query, this.$authHttp).then( res => {
        if(res.status == 200) {
          window.location.href = res.data.url
        }
      })
    }
  }
};
</script>
<style lang='less' scoped>

</style>
